import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as reducers from '../../store/reducers';
import * as usersActions from '../../store/users/actions';

import UsersListAction from 'Components/UsersListAction';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

class RemoveInvitedUserAction extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const { user, removeTeacherInvite } = this.props;
    removeTeacherInvite(user.auth_info.username, user.id);
  }

  render() {
    const { isRequesting } = this.props;
    const labelId = isRequesting
      ? 'removeInvitedUser.active'
      : 'removeInvitedUser';
    return (
      <UsersListAction
        label={
          <ConnectedFormattedMessage
            id={`users_list.action_labels.${labelId}`}
          />
        }
        iconType="trash"
        isRequesting={isRequesting}
        handleClick={this.handleClick}
      />
    );
  }
}

RemoveInvitedUserAction.propTypes = {
  isRequesting: PropTypes.bool,
  user: PropTypes.object,
  removeTeacherInvite: PropTypes.func,
};

const mapStateToProps = (state, { user }) => {
  const watchedUser = reducers.getUser(state, user.id);
  return {
    isRequesting: watchedUser.requestingRemoval,
  };
};

export default connect(mapStateToProps, {
  ...usersActions,
})(RemoveInvitedUserAction);
